import { copy } from '@/helpers/object';
import { JobSavedSearchData } from '@/interface/JobSavedSearchData';

const state = () => ({
  data: [],
  isFetching: false,
  currentSavedSearch: null,
});

const mutations = {
  setData(currentState, newValue = []) {
    currentState.data = copy(newValue);
  },
  remove(currentState, idToRemove) {
    currentState.data = currentState.data.filter(
      (savedSearch) => savedSearch.searchId !== idToRemove,
    );
  },
  update(currentState, item) {
    const { data } = currentState;
    const index = data.findIndex(({ searchId }) => searchId === item.searchId);

    if (index === -1) {
      return;
    }

    const updatedData = data.slice();
    updatedData[index] = {
      ...copy(data[index]),
      ...item,
    };

    currentState.data = updatedData;
  },
  setFetching(currentState, newValue) {
    currentState.isFetching = newValue;
  },
  setCurrentSavedSearch(currentState, newValue) {
    currentState.currentSavedSearch = newValue;
  },
};

const actions = {
  fetch({ commit, rootGetters }) {
    commit('setFetching', true);
    return this.$api
      .get(rootGetters.getApiLink('savedSearch.getAll'))
      .then(({ data }) => {
        const savedSearchList = data?.payload?.content;
        commit('setData', savedSearchList);
        return savedSearchList;
      })
      .finally(() => {
        commit('setFetching', false);
      });
  },
  save({ rootGetters }, savedSearch: JobSavedSearchData) {
    const action = savedSearch.searchId && savedSearch.searchId !== 0 ? 'update' : 'create';
    const parameters =
      action === 'update'
        ? {
            savedSearchId: savedSearch.searchId,
          }
        : null;

    return this.$api.jsonPost(
      rootGetters.getApiLink(`savedSearch.${action}`, parameters),
      savedSearch,
    );
  },
  delete({ rootGetters }, id) {
    return this.$api.delete(rootGetters.getApiLink('savedSearch.delete', { savedSearchId: id }));
  },
  setCurrentSavedSearch({ commit }, payload) {
    let savedSearch = {
      searchId: payload.searchId || payload.saved_search_id,
      searchName: payload.searchName || payload.saved_search_name,
      searchFrequency: payload.searchFrequency || payload.notification_frequency,
    };
    if (!savedSearch.searchId || !savedSearch.searchName) {
      savedSearch = null;
    }
    commit('setCurrentSavedSearch', savedSearch);
  },
};

const getters = {
  isFetching: (s) => s.isFetching,
  list: (s) => s.data,
  currentSavedSearch: (s) => s.currentSavedSearch,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
